import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../firebaseAnalytics';
import { CookieSettingsLink } from '../consent/ConsentContext';

export default function Footer(){
  const navigate = useNavigate();

  const scrollToId = useCallback((id)=>{
    const el = document.getElementById(id);
    if(el){ el.scrollIntoView({behavior:'smooth', block:'start'}); }
  }, []);

  const handleSectionLink = useCallback((e, id)=>{
    e.preventDefault();
    const isLanding = typeof window !== 'undefined' && window.location.pathname === '/';
    if(isLanding){
      scrollToId(id);
    } else {
      navigate('/', { state: { scrollToId: id } });
    }
  }, [navigate, scrollToId]);

  const handleRouteLink = useCallback((e, path)=>{
    e.preventDefault();
    if(path === '/contact'){
      trackEvent('contact_click', { source: 'footer_nav', destination: 'contact_page' });
    }
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    if(currentPath !== path){
      navigate(path);
    } else {
      window.scrollTo({top:0, behavior:'smooth'});
    }
  }, [navigate]);

  const footerLinks = useMemo(()=>[
    { label:'Features', href:'/#services', onClick: (e)=>handleSectionLink(e,'services') },
    { label:'Pricing', href:'/#pricing', onClick: (e)=>handleSectionLink(e,'pricing') },
    { label:'Changelog', href:'/changelog', onClick: (e)=>handleRouteLink(e,'/changelog') },
    { label:'Blog', href:'/blog', onClick: (e)=>handleRouteLink(e,'/blog') },
    { label:'Prompt management', href:'/blog/solutions/prompt-management', onClick: (e)=>handleRouteLink(e,'/blog/solutions/prompt-management') },
    { label:'Prompting guide', href:'/blog/guides/prompt-engineering-basics', onClick: (e)=>handleRouteLink(e,'/blog/guides/prompt-engineering-basics') },
    // { label:'Team', href:'/#team', onClick: (e)=>handleSectionLink(e,'team') },
    { label:'Contact', href:'/contact', onClick: (e)=>handleRouteLink(e,'/contact') },
    { label:'FAQ', href:'/faq', onClick: (e)=>handleRouteLink(e,'/faq') },
    { label:'Privacy', href:'/privacy', onClick: (e)=>handleRouteLink(e,'/privacy') },
    // { label:'Terms', href:'#' }
  ], [handleRouteLink, handleSectionLink]);

  return (
    <footer className="site-footer" id="footer">
      <div className="container footer">
        <div className="glass footer-glass">
          <div className="footer-meta">
            <div className="footer-meta-left">
              <div className="links footer-links">
                {footerLinks.map(link=>(
                  <a
                    key={link.label}
                    href={link.href}
                    onClick={link.onClick}
                  >
                    {link.label}
                  </a>
                ))}
                <CookieSettingsLink />
              </div>
              <div className="footer-copyright">© 2026 Promptera — all rights reserved</div>
            </div>
            <div className="social footer-social">
              <div className="footer-social-icons">
                <a className="icon-btn-foot" href="https://www.instagram.com/the.promptera/" target="_blank" rel="noopener" aria-label="Instagram"><i className="fi fi-brands-instagram"></i></a>
                <a className="icon-btn-foot" href="https://x.com/prompterastudio" target="_blank" rel="noopener" aria-label="X"><i className="fi fi-brands-twitter-alt"></i></a>
                <a className="icon-btn-foot" href="https://www.linkedin.com/company/promptera-studio" target="_blank" rel="noopener" aria-label="LinkedIn"><i className="fi fi-brands-linkedin"></i></a>
              </div>
              {/* <a
                href="mailto:info@promptera.io"
                className="footer-email"
                onClick={() => trackEvent('contact_click', { source: 'footer_email', method: 'mailto' })}
              >
                info@promptera.io
              </a> */}
            </div>
          </div>
        </div>
        <a
          className="footer-wordmark"
          href="/#top"
          onClick={(e) => handleSectionLink(e, 'top')}
          aria-label="Promptera home"
        >
          <svg className="footer-mark" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
            <defs>
              <filter id="footer-mark-outline" x="-8%" y="-8%" width="116%" height="116%">
                <feMorphology in="SourceAlpha" operator="dilate" radius="3" result="expanded" />
                <feComposite in="expanded" in2="SourceAlpha" operator="out" result="outline" />
                <feFlood floodColor="#a78bfa" floodOpacity="0.62" result="stroke" />
                <feComposite in="stroke" in2="outline" operator="in" />
              </filter>
            </defs>
            <image
              href="/Icon/Final%20Logos/Logo_Transparent_Favicon_Large.png"
              width="512"
              height="512"
              filter="url(#footer-mark-outline)"
            />
            <rect x="276" y="110" width="58" height="97" rx="29" transform="rotate(-10 305 158)" fill="none" stroke="#a78bfa" strokeOpacity="0.62" strokeWidth="5" />
            <rect x="351" y="91" width="58" height="100" rx="29" transform="rotate(-10 380 141)" fill="none" stroke="#a78bfa" strokeOpacity="0.62" strokeWidth="5" />
          </svg>
          <span>Promptera</span>
        </a>
      </div>
    </footer>
  );
}
